import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantUserAppOperation = {
  namespaced: true,

  state: () => ({
    editMerchantUserAppOperationClicked: false,
    selectedMerchantUserAppOperation: null,
    allMerchantUserAppOperations: []
  }),

  getters: {
    _editMerchantUserAppOperationClicked: state => state.editMerchantUserAppOperationClicked,
    _selectedMerchantUserAppOperation: state => state.selectedMerchantUserAppOperation,
    _allMerchantUserAppOperations: state => state.allMerchantUserAppOperations
  },

  mutations: {
    EDIT_MERCHANT_USER_APP_OPERATION_CLICKED (state, data) {
      state.editMerchantUserAppOperationClicked = data
    },
    SELECTED_MERCHANT_USER_APP_OPERATION (state, data) {
      state.selectedMerchantUserAppOperation = data
    },
    ALL_MERCHANT_USER_APP_OPERATIONS (state, data) {
      state.allMerchantUserAppOperations = data
    }
  },

  actions: {
    CreateMerchantUserAppOperation ({ rootState, dispatch }, { headers, data }) {
      rootState.loading = true
      return new Promise((resolve, reject) => {
        api.post('/MerchantUserAppOperation/CreateMerchantUserAppOperation', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantUserAppOperation ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantUserAppOperation/UpdateMerchantUserAppOperation', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantAppOperation ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantUserAppOperation/DeleteMerchantMerchantAppOperation', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllMerchantUserAppOperation ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantUserAppOperation/GetAllMerchantUserAppOperation', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllMerchantUserAppOperationByMerchantUserAppOperationID ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantUserAppOperation/GetAllMerchantUserAppOperationByID?MerchantUserAppOperationID=${payload.merchantUserAppOperationID}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetMerchantUserAppOperationByMerchantUserId ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantUserAppOperation/GetByUserIdMerchantUserAppOperation?UserId=${payload.userId}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantUserAppOperation
